/**
 *
 * @param {string | undefined} isReferrer
 */
export function redirectBack(isReferrer = '') {
  const isHistory = window.history.length > 1;

  if (!(isReferrer && isHistory)) {
    window.location.href = '/';
  } else {
    window.history.back();
  }
}

export default redirectBack;
